var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"}},[_c('path',{attrs:{"d":"M10.834 9.16634L6.66732 4.99967L10.834 0.833008M5.00065 9.16634L0.833984 4.99967L5.00065 0.833008","stroke":"#344054","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }